import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Switch,
  Button,
  IconButton,
  Box
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DragHandleIcon from "@mui/icons-material/DragHandle";
import apiRequest from "./../../../../apiRequest"; // Adjust path as needed

function CategoryTable({
  subCategories,
  selectedParent,
  isReordering,
  handleDragEnd,
  handleStatusToggle,
  handleEdit,
  handleDeleteClick,
}) {
  return (
    <TableContainer component={Paper} style={{ marginTop: "16px" }}>
      <Table>
        <TableRow>
          <TableCell style={{ fontWeight: "bold", width: 50 }}></TableCell>
          <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
          <TableCell style={{ fontWeight: "bold" }}>Parent</TableCell>
          <TableCell style={{ fontWeight: "bold" }}>Service Type</TableCell>
          <TableCell style={{ fontWeight: "bold" }}>Services</TableCell>
          <TableCell style={{ fontWeight: "bold" }}>Min Price</TableCell>
          <TableCell style={{ fontWeight: "bold" }}>Double Location</TableCell>
          <TableCell style={{ fontWeight: "bold" }}>Photo</TableCell>
          <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
          <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
        </TableRow>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="subCategories">
            {(provided) => (
              <TableBody
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {subCategories.map((subCat, index) => (
                  <Draggable
                    key={subCat.id}
                    draggableId={String(subCat.id)}
                    index={index}
                    isDragDisabled={!selectedParent || isReordering}
                  >
                    {(provided) => (
                      <TableRow
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        hover
                      >
                        {/* Drag Handle */}
                        <TableCell
                          {...provided.dragHandleProps}
                          style={{ cursor: selectedParent ? 'grab' : 'default' }}
                        >
                          <IconButton disabled={!selectedParent || isReordering}>
                            <DragHandleIcon />
                          </IconButton>
                        </TableCell>

                        <TableCell>{subCat.name_en + ' / ' + subCat.name_fr}</TableCell>
                        <TableCell>
                          {subCat.parent_categories?.map((cat, index) => (
                            <div key={index}>
                              {cat.name_en} / {cat.name_fr}
                            </div>
                          ))}
                        </TableCell>

                        <TableCell>{subCat.service_type?.name_en + ' / ' + subCat.service_type?.name_fr}</TableCell>
                        <TableCell>
                          <ul style={{ listStyleType: "disc", paddingLeft: "20px", margin: 0 }}>
                            {(Array.isArray(subCat.services) ? subCat.services : JSON.parse(subCat.services || "[]")).map(
                              (service, index) => (
                                <li key={index}>{`${service.name_en}`}</li>
                              )
                            )}
                          </ul>
                        </TableCell>
                        <TableCell>{subCat.min_price}</TableCell>
                        <TableCell>{subCat.double_location ? "Yes" : "No"}</TableCell>
                        <TableCell>
                          <img
                            src={`${apiRequest.BASE_URL}/${subCat.image}`}
                            alt={subCat.name_en}
                            style={{ width: "100px", height: "auto" }}
                          />
                        </TableCell>
                        <TableCell>
                          <Switch
                            checked={subCat.status === "active"}
                            onChange={() => handleStatusToggle(subCat.id, subCat.status)}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1, // adds space between buttons
                            }}
                          >
                            <Button
                              onClick={() => handleEdit(subCat)}
                              color="primary"
                              size="small"
                            >
                              Edit
                            </Button>
                            <Button
                              onClick={() => handleDeleteClick(subCat.id)}
                              color="error"
                              size="small"
                            >
                              Delete
                            </Button>
                          </Box>
                        </TableCell>

                      </TableRow>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </DragDropContext>
      </Table>
    </TableContainer>
  );
}

export default CategoryTable;